"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledScrollDiv = exports.classes = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var Avatar_1 = __importDefault(require("components/Avatars/Avatar"));
var ScrollDiv_1 = __importDefault(require("components/Layout/ScrollDiv"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var single_1 = require("utils/selectors/single");
var DefaultTeams_1 = __importDefault(require("./DefaultTeams"));
var PREFIX = 'TeamsPreview';
exports.classes = {
    avatar: "".concat(PREFIX, "-avatar"),
    contentWrapper: "".concat(PREFIX, "-contentWrapper"),
    livePreviewWrapper: "".concat(PREFIX, "-livePreviewWrapper"),
    teamsWrapper: "".concat(PREFIX, "-teamsWrapper"),
};
exports.StyledScrollDiv = (0, material_1.styled)(ScrollDiv_1.default)(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(exports.classes.avatar)] = {
            height: 32,
            width: 32,
            marginRight: theme.spacing(2),
        },
        _b[".".concat(exports.classes.contentWrapper)] = {
            width: '100%',
            margin: '0 auto',
            display: 'flex',
            justifyContent: 'center',
            padding: theme.spacing(8, 0),
        },
        _b[".".concat(exports.classes.livePreviewWrapper)] = (_c = {
                background: theme.palette.common.white,
                borderRadius: 10,
                width: '100%',
                overflowX: 'hidden',
                display: 'flex',
                flexDirection: 'column'
            },
            _c[theme.breakpoints.up('xl')] = {
                maxWidth: 900,
            },
            _c[theme.breakpoints.only('lg')] = {
                maxWidth: 750,
            },
            _c[theme.breakpoints.only('md')] = {
                maxWidth: 600,
            },
            _c[theme.breakpoints.down('lg')] = {
                display: 'none',
            },
            _c),
        _b[".".concat(exports.classes.teamsWrapper)] = (_d = {},
            _d[theme.breakpoints.up('xl')] = {
                width: 890,
            },
            _d[theme.breakpoints.only('lg')] = {
                width: 725,
            },
            _d[theme.breakpoints.only('md')] = {
                width: 500,
            },
            _d),
        _b);
});
var TeamsPreview = function (_a) {
    var TeamsDetailsWrapper = _a.TeamsDetailsWrapper;
    var teams = (0, react_final_form_1.useFormState)({ subscription: { values: true } }).values.teams;
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    return ((0, jsx_runtime_1.jsx)(exports.StyledScrollDiv, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: exports.classes.contentWrapper }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: exports.classes.livePreviewWrapper }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ pt: 5, pl: 5, display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(Avatar_1.default, { className: exports.classes.avatar, profile: company }), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: company === null || company === void 0 ? void 0 : company.name }))] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ className: exports.classes.teamsWrapper, px: 5, my: 5 }, { children: [teams === null || teams === void 0 ? void 0 : teams.map(function (team) { return (0, jsx_runtime_1.jsx)(TeamsDetailsWrapper, { team: team }, team.id); }), (teams === null || teams === void 0 ? void 0 : teams.length) < 6 && __spreadArray([], __read(Array(6 - ((teams === null || teams === void 0 ? void 0 : teams.length) || 0)).keys()), false).map(function (v) { return (0, jsx_runtime_1.jsx)(DefaultTeams_1.default, {}, v); })] }))] })) })) }));
};
exports.default = TeamsPreview;
